
import { useTranslation } from 'react-i18next';

export default function VisionMissionSection() {
  const { t } = useTranslation();

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            {t('vision_mission_title')}
          </h2>
          <p className="text-lg text-gray-600 mb-2">{t('vision_mission_subtitle')}</p>
          <div className="w-24 h-1 bg-gradient-to-r from-blue-600 to-purple-600 mx-auto mb-8"></div>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div>
            <img 
              src="/resources/vision-mission-001.jpg"
              alt={t('vision_mission_title')}
              className="rounded-2xl shadow-2xl object-cover w-full h-96"
            />
          </div>
          <div>
            <div className="mb-12">
              <div className="w-12 h-12 bg-gradient-to-r from-blue-600 to-purple-600 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-eye-line text-white text-2xl"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                {t('our_vision')}
              </h3>
              <p className="text-lg text-gray-600 leading-relaxed">
                {t('our_vision_desc')}
              </p>
            </div>
            
            <div>
              <div className="w-12 h-12 bg-gradient-to-r from-purple-600 to-pink-600 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-target-line text-white text-2xl"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                {t('our_mission')}
              </h3>
              <p className="text-lg text-gray-600 leading-relaxed">
                {t('our_mission_desc')}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
